// extracted by mini-css-extract-plugin
export default {"Box":"filter-input-actions-module__Box--qP9X9","Box_1":"filter-input-actions-module__Box_1--eOqS_"};